function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 110 16A8 8 0 018 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.91 6a1.91 1.91 0 11-.003 3.819A1.91 1.91 0 013.91 6zm4.39.034c.06-.05.206-.032.304-.025l.052.003h.98l-.138.323-.274.565-.83 1.721-.009.404.013.793H7.069v-.82l-.008-.39-1.243-2.583.336-.013h.657l.344.014.156.295.26.538.143.323.064-.09c.037-.065.065-.142.097-.206l.275-.565c.04-.083.08-.228.15-.287zM11.545 6a1.91 1.91 0 11-.002 3.82A1.91 1.91 0 0111.546 6zm-.029 1.214l-.092.009a.659.659 0 00-.25.099c-.59.372-.233 1.338.46 1.227a.705.705 0 00.275-.105c.551-.352.27-1.165-.304-1.226l-.089-.004zm-7.633.001l-.097.008a.699.699 0 00-.263.095c-.595.378-.234 1.331.46 1.232a.698.698 0 00.262-.096c.551-.342.298-1.156-.27-1.233l-.092-.006z"
}));

function SvgHappyOyo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappyOyo;